const ROUTE = {
  NOT_FOUND: '/not-found/entitiy',
  NOT_ACTIVE: '/inactive/entitiy',
  NOT_AVAILABLE: '/not-available',
  LOGIN: '/login/*',
  RESET_PASSWORD: '/reset-password/*',
  RESET_TEMP_PASSWORD: '/reset-temp-password/*',
  FORGOT_PASSWORD: '/forgot-password/*',
  HEALTH: '/health',
  DASHBOARD: '/*',
  PROFILE: '/profile/*',
  SCHEDULES: '/schedules',
  SESSIONS: '/sessions/*',
  MEDIA_LIBRARY: '/media-library/*',
  MEDIA_LIBRARY_RECORD_CONTENT: '/media/record-content',
  GROUPS: '/groups/*',
  USERS: '/users/*',
  ARTICLES: '/articles/*',
  FORMS: '/forms/*',
  NEWSFEED: '/newsfeed/*',
  WALLET: '/wallet/*',
  REVIEW: '/reviews/*',
  TERMS: '/terms-and-conditions',
  PRIVACY: '/privacy-policy',
};
export default ROUTE;
